import { CONTACT_EMAIL } from "../config/contact";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { CatalogueRings } from "../components/CatalogueRings";
import { useCatalogue } from "../data/ContentProvider";
import { useLocalizedPath } from "../localization/urls";
import "./Home.css";

export function Home() {
  const { t } = useTranslation();
  const { state, trees, content } = useCatalogue();
  const path = useLocalizedPath();

  return (
    <div className="home">
      <section className="home-hero" aria-busy={state === "loading" ? true : undefined}>
        <div className="home-copy">
          <h1>{t("hero.title")}</h1>
          <p className="home-lede">{t("hero.body")}</p>

          {state === "error" ? <p role="alert">{t("catalogue.error")}</p> : (
            <div className="home-tally">
              <strong className="datum">{trees.length}</strong>
              <span className="label">{t("count.catalogue")}</span>
            </div>
          )}

          <div className="home-actions">
            <Link className="home-button home-button-primary" to={path("/map")}>{t("nav.map")}</Link>
            <Link className="home-button" to={path("/catalog")}>{t("nav.catalogue")}</Link>
          </div>
        </div>

        <div className="home-rings-wrap">
          <CatalogueRings trees={trees} content={content} />
        </div>
      </section>

      <section className="home-about" aria-labelledby="home-about-title">
        <h2 id="home-about-title">{t("about.title")}</h2>
        <div className="home-about-copy">
          <p>{t("about.body")}</p>
          <p>{t("about.licensing")}</p>
          <p>
            {t("about.corrections")} {" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </div>
      </section>
    </div>
  );
}
